import { Link, useParams } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { Button } from '@reflex/ui/components/ui/button';
import { AdminSubPageLayout } from '@reflex/ui/components/layout/AdminSubPageLayout';
import { AdminOrgUsageDetail } from '@/components/monitor/AdminOrgUsageDetail';
import { useAuth } from '@/hooks/auth/useAuth';
import { useUsageSnapshot } from '@/hooks/admin/useUsageSnapshot';
import { ROUTES } from '@/lib/routes';

/**
 * Super-admin drill-down page for a single organization's live usage,
 * reached from the Per-Org Usage table on the monitor page. Subscribes to
 * the same WebSocket usage snapshot as the monitor page and scopes it to
 * the org in the URL.
 */
export function MonitorOrgDetailPage() {
  const { organizationId = '' } = useParams<{ organizationId: string }>();
  const { isPlatformAdmin } = useAuth();
  const { snapshot } = useUsageSnapshot(isPlatformAdmin);

  const org = snapshot?.perOrg.find((o) => o.organizationId === organizationId) ?? null;
  const title = org?.name ?? org?.slug ?? 'Organization usage';

  const backAction = (
    <Button asChild variant="outline" size="sm">
      <Link to={ROUTES.admin.monitor}>Back to monitor</Link>
    </Button>
  );

  return (
    <AdminSubPageLayout
      title={title}
      icon={<Building2 />}
      description="Live usage for this organization, broken down by team and user."
      actions={backAction}
    >
      <AdminOrgUsageDetail organizationId={organizationId} snapshot={snapshot} />
    </AdminSubPageLayout>
  );
}
